import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import {
  EMPTY,
  exhaustMap,
  map,
  Observable,
  OperatorFunction,
  pipe,
  UnaryFunction,
} from 'rxjs';
import { ConfirmDialogComponent } from '../components/dialog/confirm-dialog.component';
import { FileDetails } from '../models/file-details.model';

export interface ConfirmDialogOptions {
  title: string;
  message: string;
  messageParam: string
}

@Injectable({
  providedIn: 'root'
})export class ConfirmDialogService {
  constructor(
    private readonly matDialog: MatDialog,
    private readonly translateService: TranslateService,
  ) {}

  public open(confirmDialogOptions: ConfirmDialogOptions): Observable<boolean> {
    return this.matDialog
      .open(ConfirmDialogComponent, {
        data: {
          title: this.translateService.instant(confirmDialogOptions.title),
          message: this.translateService.instant(confirmDialogOptions.message, { filename: confirmDialogOptions.messageParam})
        },
        disableClose: true
      })
      .afterClosed()
      .pipe(
        map(result => !!result)
      );
  }

  public info(
    config: Omit<ConfirmDialogOptions, 'cancel'>,
  ): Observable<boolean> {
    return this.matDialog
      .open(ConfirmDialogComponent, {
        data: {
          ...config,
          confirm:
            this.translateService.instant('GENERICS.YES') as string,
          cancel: undefined,
        },
      })
      .afterClosed();
  }

  public confirmPipe<T>(
    config: ConfirmDialogOptions,
  ): UnaryFunction<Observable<T | null | undefined>, Observable<T>> {
    return pipe(
      exhaustMap((args) =>
        this.open(config).pipe(map((response) => (response ? args : EMPTY))),
      ) as OperatorFunction<T | null | undefined, T>,
    );
  }
}
